
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/voucher",
      function () {
        return require("private-next-pages/shop/voucher.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/voucher"])
      });
    }
  